export const PAGE_SIZE = {
  /** Must stay within backend PaginationQueryDto MAX_ITEMS_PER_PAGE (50). */
  ALLOWED_PLATE_NUMBERS: 50,
  CAMERA_MEDIA_LIST: 10,
  DEFAULT_LIST_IN_FORM: 5,
  DEFAULT_TABLE: 20,
  NOTIFICATIONS: 20,
  SAFETY_CHECK_IN_TABLE: 10,
  SUBSCRIPTION_TABLE: 5
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}